












import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Bridge from "@/common/bridge";
import getUrlParam from '@/common/utils/getUrlParam';
import { isXiaomaiApp } from "@/common/utils/getPlaform";

@Component
export default class ContactIcon extends Vue {
  @Getter("contactIcon")
  contactIcon!: string;

  @Getter("instPhone")
  instPhone!: string;
  
   @Getter("distributeTabFixed") distributeTabFixed!:boolean;
  getUrlParam: Function = getUrlParam;
  isXiaomaiApp: Function = isXiaomaiApp;

  get callPhone(): string {
    return "tel:" + this.instPhone;
  }

  handleAppCall() {
    if (isXiaomaiApp() && this.instPhone) {
      Bridge.callHandler((Api: any) => {
        Api.callContact({ number: this.instPhone });
      });
    }
  }
}
